import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from '@/shared/lib/sentry'
import '@/shared/index.css'
import './lib/i18n'
import App from './App'

initSentry('iris')

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
